import { createContext } from 'react'

const PageConfigContext = createContext({})

export default PageConfigContext
